"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Serventias = void 0;
var React = require("react");
var microsoftTeams = require("@microsoft/teams-js");
var Icons_1 = require("office-ui-fabric-react/lib/Icons");
var user_api_1 = require("../../api/user-api");
var serventias_api_1 = require("../../api/serventias-api");
var react_northstar_1 = require("@fluentui/react-northstar");
var react_icons_northstar_1 = require("@fluentui/react-icons-northstar");
var Icon_1 = require("office-ui-fabric-react/lib/Icon");
var visao_geral_atendimentos_1 = require("./visao-geral-atendimentos/visao-geral-atendimentos");
var visao_geral_unidades_1 = require("./visao-geral-unidades/visao-geral-unidades");
var media_atendimentos_1 = require("./media-atendimentos/media-atendimentos");
var pagination_1 = require("../pagination/pagination");
var serventias_columns_1 = require("../../constants/serventias-columns");
var serventias_filters_1 = require("../../constants/serventias-filters");
var errors_1 = require("../../constants/errors");
var roles_1 = require("../../constants/roles");
var loader_1 = require("../loaders/loader");
var loaderList_1 = require("../loaders/loaderList");
var Chart_1 = require("../chart/Chart");
var ChartTypes_1 = require("../chart/ChartTypes");
var lodash_1 = require("lodash");
require("./serventias.scss");
var Serventias = /** @class */ (function (_super) {
    __extends(Serventias, _super);
    function Serventias(props) {
        var _this = _super.call(this, props) || this;
        _this.defaultPageSize = 10;
        _this.pageId = 2;
        _this.searchParam = null;
        _this.upn = null;
        _this.aadId = null;
        _this.user = null;
        _this.tid = null;
        _this.loginHint = null;
        _this.init = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.getPageSize();
                this.getItemsSecaoJudiciariaFilters();
                this.getMeetingsData(true);
                this.getMeetingsPagedData(0, this.defaultPageSize);
                this.getAtendimentosFilteredMetrics(0); // Visão geral de atendimentos
                this.getAtendimentosTotalMetrics(); // Visão geral de atendimentos (totais)
                this.getUnidadesFilteredMetrics(7); // Visão geral das unidades
                this.getRelatorioAtendimentosFilteredMetrics(7);
                return [2 /*return*/];
            });
        }); };
        //Setup app & Report
        _this.setupApp = function () { return __awaiter(_this, void 0, void 0, function () {
            var responseSetup, responseReport;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, serventias_api_1.getAppSetup()];
                    case 1:
                        responseSetup = _a.sent();
                        return [4 /*yield*/, serventias_api_1.getReportUrl()];
                    case 2:
                        responseReport = _a.sent();
                        if (responseSetup && responseReport) {
                            this.setState({
                                setup: responseSetup.data,
                                reportUrl: responseReport.data,
                            });
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        //Setup user settings
        _this.setupUser = function (userSettings) { return __awaiter(_this, void 0, void 0, function () {
            var responseGet;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, user_api_1.getUserSettings(this.loginHint)];
                    case 1:
                        responseGet = _a.sent();
                        if (responseGet.data) {
                            this.setState({
                                userSettings: responseGet.data,
                                pinnedAncoras: responseGet.data.PinnedAncoras || [],
                                selectedViewFilter: responseGet.data.LastSelectedView,
                            });
                            this.init();
                        }
                        else {
                            window.location.href = "/errorpage/" + errors_1.default.invalidUserData;
                            this.init();
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        //Update favorites
        _this.updateFavorites = function (userSettings) { return __awaiter(_this, void 0, void 0, function () {
            var responseUpdate;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, user_api_1.updateUserSettings(userSettings)];
                    case 1:
                        responseUpdate = _a.sent();
                        if (responseUpdate.status === 200 && responseUpdate.data) {
                            this.setState({
                                pinnedAncoras: responseUpdate.data
                            });
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        //Get Page size initial
        _this.getPageSize = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.setState({
                    pageSize: 10
                });
                return [2 /*return*/];
            });
        }); };
        /**
         * Get Filtered Metrics Data
         * */
        _this.getRelatorioAtendimentosFilteredMetrics = function (daysCount, index) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (index == null) {
                            this.setState({
                                loadingMetricsFiltered: true,
                            });
                        }
                        return [4 /*yield*/, serventias_api_1.getAttendancesReportData(daysCount)];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200 && response.data) {
                            this.setState({
                                relatorioAtendimentosFilteredMetrics: response.data,
                                loadingMetricsFiltered: false,
                                relatorioAtendimentosIndex: index == null ? 0 : index,
                            });
                        }
                        else {
                            this.setState({
                                relatorioAtendimentosFilteredMetrics: null,
                                loadingMetricsFiltered: false,
                            });
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        /**
         * Get visão geral filter metrics
         * */
        _this.getAtendimentosFilteredMetrics = function (daysCount, index) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (index == null) {
                            this.setState({
                                loadingAtendimentosMetricsFiltered: true,
                            });
                        }
                        return [4 /*yield*/, serventias_api_1.getGeneralViewData(daysCount)];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200 && response.data) {
                            this.setState({
                                atendimentosMetricsFiltered: response.data,
                                loadingAtendimentosMetricsFiltered: false,
                                atendimentosIndex: index == null ? 0 : index,
                            });
                        }
                        else {
                            this.setState({
                                atendimentosMetricsFiltered: null,
                                loadingAtendimentosMetricsFiltered: false,
                            });
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        /**
         * Get visão geral total metrics
         * */
        _this.getAtendimentosTotalMetrics = function () { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({
                            loadingAtendimentosTotalMetrics: true,
                        });
                        return [4 /*yield*/, serventias_api_1.getMetricsData()];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200 && response.data) {
                            this.setState({
                                atendimentosTotalMetrics: response.data,
                                loadingAtendimentosTotalMetrics: false,
                            });
                        }
                        else {
                            this.setState({
                                atendimentosTotalMetrics: null,
                                loadingAtendimentosTotalMetrics: false,
                            });
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        /**
         * Get visão geral unidades
         * */
        _this.getUnidadesFilteredMetrics = function (daysCount, index) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (index == null) {
                            this.setState({
                                loadingUnidadesMetricsFiltered: true,
                            });
                        }
                        return [4 /*yield*/, serventias_api_1.getActiveUnidadesData(daysCount)];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200 && response.data) {
                            this.setState({
                                unidadesMetricsFiltered: response.data,
                                loadingUnidadesMetricsFiltered: false,
                                unidadesIndex: index == null ? 0 : index,
                            });
                        }
                        else {
                            this.setState({
                                unidadesMetricsFiltered: null,
                                loadingUnidadesMetricsFiltered: false,
                            });
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        //"Search function"
        _this.search = function (e) {
            var searchQuery = e.target.value;
            _this.onChangeDebounced(searchQuery.toLowerCase());
        };
        _this.onChangeDebounced = function (queryText) {
            _this.setState({ searchFilter: queryText });
            _this.getMeetingsData();
            _this.getMeetingsPagedData(0, _this.state.pageSize, queryText, undefined, undefined, _this.state.secaoJudiciariaChecked, _this.state.selectedViewFilter);
        };
        // "Individual record checkbox selected"
        _this.selectCheckboxChanged = function (e, v) {
            var selectedChkId = e.currentTarget.id;
            _this.state.items.forEach(function (currentItem) {
                if (currentItem.ancora === selectedChkId) {
                    currentItem.isSelected = v.checked ? v.checked : false;
                    _this.setState({ selectedItem: currentItem });
                }
                else {
                    currentItem.isSelected = false;
                }
            });
            _this.setState({
                items: _this.state.items
            });
            _this.populateRows();
        };
        // "Set favorite item"
        _this.setFavorite = function (item, ancora, index) {
            if (item.favorite) {
                var indexAncora = _this.state.pinnedAncoras.indexOf(ancora);
                if (indexAncora > -1) {
                    _this.state.pinnedAncoras.splice(indexAncora, 1);
                }
            }
            else {
                _this.state.pinnedAncoras.push(ancora);
            }
            _this.updateFavorites(_this.state.userSettings);
            var favoriteItem = __spreadArrays(_this.state.items);
            favoriteItem[index].favorite = item.favorite ? false : true;
            _this.setState({ items: favoriteItem });
            _this.populateRows();
        };
        //#region "Sorting functions"
        //Calling appropriate function based on column selected for sorting
        _this.sortDataByColumn = function (column, sortState) {
            var _a;
            var directionBool = false;
            var direction = _this.state[sortState] === "Up" ? "Down" : "Up";
            _this.setState((_a = {
                    sortedColumn: column
                },
                _a[sortState] = direction,
                _a));
            directionBool = _this.state[sortState] === "Up" ? true : false;
            _this.sortColumnItems(column, directionBool);
        };
        //Setting the sort icons and sorting pinned-unpinned records separately
        _this.sortColumnItems = function (sortColumn, sortOrder) {
            var sorted = sortOrder === true ? "asc" : "desc";
            if (sortColumn == "Favorite") {
                sorted = "asc";
            }
            _this.getMeetingsPagedData(0, _this.state.pageSize, _this.state.searchFilter, sortColumn, sorted, _this.state.secaoJudiciariaChecked, _this.state.selectedViewFilter);
        };
        //#endregion "Sorting functions"
        _this.selectFilter = function (e, v) {
            var selectedChkId = e.currentTarget.id;
            if (v.checked) {
                _this.setState({
                    totalFilterChecked: /*this.state.totalFilterChecked +*/ 1,
                    secaoJudiciariaChecked: selectedChkId,
                    activePage: 0
                }, function () {
                    _this.getMeetingsData();
                    _this.getMeetingsPagedData(0, _this.state.pageSize, _this.state.searchFilter, _this.state.sortedColumn, _this.state.sortDirection, selectedChkId, _this.state.selectedViewFilter);
                });
            }
            else {
                _this.setState({
                    totalFilterChecked: _this.state.totalFilterChecked - 1,
                    secaoJudiciariaChecked: "",
                    activePage: 0
                }, function () {
                    _this.getMeetingsData();
                    _this.getMeetingsPagedData(0, _this.state.pageSize, _this.state.searchFilter);
                });
            }
            _this.state.itemsSecaoFilter.forEach(function (currentItem) {
                if (currentItem.name === selectedChkId) {
                    currentItem.isSelected = v.checked ? v.checked : false;
                }
                else {
                    currentItem.isSelected = false;
                }
            });
            _this.setState({
                itemsSecaoFilter: _this.state.itemsSecaoFilter
            });
        };
        _this.setActivePage = function (newPageNumber) {
            var sorted = undefined;
            if (_this.state.sortedColumn == serventias_columns_1.default.name) {
                sorted = _this.state.sortDirection === "Down" ? "asc" : "desc";
            }
            else if (_this.state.sortedColumn == serventias_columns_1.default.secaoJudiciaria) {
                sorted = _this.state.sortDirectionSecao === "Down" ? "asc" : "desc";
            }
            _this.getMeetingsPagedData(newPageNumber * _this.state.pageSize, _this.state.pageSize, _this.state.searchFilter, _this.state.sortedColumn, sorted, _this.state.secaoJudiciariaChecked, _this.state.selectedViewFilter);
            _this.setState({
                activePage: newPageNumber,
            });
        };
        _this.onNewBalcaoVirtual = function () {
            var taskInfo = {
                url: window.location.origin + "/form-balcao-virtual",
                title: "Novo Balcão Virtual",
                height: 700,
                width: 600,
                fallbackUrl: window.location.origin + "/form-balcao-virtual",
            };
            var submitHandler = function (err, result) {
                _this.getMeetingsPagedData(0, _this.state.pageSize, _this.state.searchFilter, undefined, undefined, _this.state.secaoJudiciariaChecked, _this.state.selectedViewFilter);
            };
            microsoftTeams.tasks.startTask(taskInfo, submitHandler);
        };
        _this.configAppSettings = function () {
            var taskInfo = {
                url: window.location.origin + ("/config-app/" + _this.aadId),
                title: "Configurações de Serviço",
                height: 700,
                width: 600,
                fallbackUrl: window.location.origin + ("/config-app/" + _this.aadId),
            };
            var submitHandler = function (err, result) {
            };
            microsoftTeams.tasks.startTask(taskInfo, submitHandler);
        };
        _this.dashboardTask = function () {
            window.open(_this.state.reportUrl + "&filterPaneEnabled=false&navContentPaneEnabled=false", '_blank');
        };
        _this.onEditBalcaoVirtual = function (ancora) {
            var taskInfo = {
                url: window.location.origin + ("/form-balcao-virtual/" + ancora),
                title: "Editar Balcão Virtual",
                height: 700,
                width: 600,
                fallbackUrl: window.location.origin + ("/form-balcao-virtual/" + ancora),
            };
            var submitHandler = function (err, result) {
                _this.getMeetingsPagedData(0, _this.state.pageSize, _this.state.searchFilter, undefined, undefined, _this.state.secaoJudiciariaChecked, _this.state.selectedViewFilter);
            };
            microsoftTeams.tasks.startTask(taskInfo, submitHandler);
        };
        _this.copyEnderecoPublicoToClipboard = function (ancora) {
            var el = document.createElement('input');
            el.style.position = 'fixed';
            el.style.left = '0';
            el.style.top = '0';
            el.style.opacity = '0';
            el.value = window.location.origin + "/meeting/" + ancora;
            document.body.appendChild(el);
            el.focus();
            el.select();
            document.execCommand("copy");
            document.body.removeChild(el);
        };
        _this.onDeleteBalcaoVirtual = function (ancora) { return __awaiter(_this, void 0, void 0, function () {
            var indexAncora, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.state.pinnedAncoras) {
                            indexAncora = this.state.pinnedAncoras.indexOf(ancora);
                            if (indexAncora > -1) {
                                this.state.pinnedAncoras.splice(indexAncora, 1);
                            }
                            this.updateFavorites(this.state.userSettings);
                        }
                        return [4 /*yield*/, serventias_api_1.deleteServentia(ancora)];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200 && response.data) {
                            this.getMeetingsPagedData(0, this.state.pageSize);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this.saveSelectedView = function (selectedView) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, user_api_1.updateLastSelectedView(selectedView)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        Icons_1.initializeIcons();
        _this.state = {
            totalItemsCount: [],
            items: [],
            selectedItem: [],
            itemsClone: [],
            loading: true,
            pageSize: _this.defaultPageSize,
            activePage: 0,
            sortedColumn: "",
            sortDirection: "Down",
            sortDirectionSecao: "Down",
            sortDirectionFluxo: "Down",
            sortDirectionHoje: "Down",
            totalFilterChecked: 0,
            itemsSecaoFilter: [],
            relatorioAtendimentosFilteredMetrics: [],
            loadingMetricsFiltered: false,
            relatorioAtendimentosIndex: 0,
            atendimentosMetricsFiltered: [],
            atendimentosIndex: 0,
            loadingAtendimentosMetricsFiltered: false,
            atendimentosTotalMetrics: [],
            loadingAtendimentosTotalMetrics: false,
            unidadesMetricsFiltered: [],
            loadingUnidadesMetricsFiltered: false,
            unidadesIndex: 0,
            loadingRows: false,
            segmentRows: [],
            isAdmin: false,
            searchFilter: "",
            userSettings: [],
            pinnedAncoras: [],
            role: roles_1.default.leitor,
            secaoJudiciariaChecked: "",
            viewFilters: [
                serventias_filters_1.default.ativos,
                serventias_filters_1.default.excluidos,
                serventias_filters_1.default.todos,
                serventias_filters_1.default.favoritos,
            ],
            selectedViewFilter: null,
            setup: null,
            reportUrl: undefined,
        };
        _this.onChangeDebounced = lodash_1.debounce(_this.onChangeDebounced, 500);
        _this.searchParam = new URLSearchParams(window.location.search);
        return _this;
    }
    Serventias.prototype.componentDidMount = function () {
        var _this = this;
        microsoftTeams.initialize();
        microsoftTeams.getContext(function (context) {
            _this.upn = context.userPrincipalName;
            _this.aadId = context.userObjectId;
            _this.user = context.loginHint;
            _this.tid = context.tid;
            _this.loginHint = context.loginHint;
            var userSettings = {
                Upn: _this.upn,
                UserData: _this.aadId,
                AadId: _this.aadId,
                UserId: _this.aadId,
                UserName: _this.user,
                TenantId: _this.tid,
            };
            _this.setupApp();
            _this.setupUser(userSettings);
            serventias_api_1.getUserPermissions().then(function (response) {
                _this.setState({
                    role: response.data
                });
            });
            _this.isAdmin();
        });
    };
    //Get Itens Tipo/Categoria
    Serventias.prototype.getItemsSecaoJudiciariaFilters = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, secaoJudiciaria_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, serventias_api_1.getMeetingsData()];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200 && response.data) {
                            secaoJudiciaria_1 = [];
                            response.data.secoesJudiciarias.forEach(function (item) {
                                var itemSecaoJudiciaria = { name: item, isSelected: item == _this.state.secaoJudiciariaChecked ? true : false };
                                secaoJudiciaria_1.push(itemSecaoJudiciaria);
                            });
                            this.setState({
                                itemsSecaoFilter: secaoJudiciaria_1
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get Meetings Data
     * */
    Serventias.prototype.getMeetingsData = function (render, filterView) {
        return __awaiter(this, void 0, void 0, function () {
            var filter, secaoJudiciaria, pinnedAncoras, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        filter = this.state.searchFilter != "" ? this.state.searchFilter : undefined;
                        secaoJudiciaria = this.state.secaoJudiciariaChecked != "" ? this.state.secaoJudiciariaChecked : undefined;
                        filterView = filterView ? filterView : this.state.selectedViewFilter;
                        pinnedAncoras = null;
                        if (this.state.pinnedAncoras) {
                            pinnedAncoras = this.state.pinnedAncoras.length ? this.state.pinnedAncoras : null;
                        }
                        if (!render) {
                            this.setState({
                                loadingRows: true,
                            });
                        }
                        else {
                            this.setState({
                                loading: true,
                            });
                        }
                        return [4 /*yield*/, serventias_api_1.getMeetingsData(filter, secaoJudiciaria, filterView, pinnedAncoras)];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200 && response.data) {
                            this.setState({
                                totalItemsCount: response.data.count,
                                loading: false,
                                selectedViewFilter: this.state.selectedViewFilter ? this.state.selectedViewFilter : response.data.selectedViewFilter
                            });
                        }
                        else {
                            this.setState({
                                loadingRows: false,
                                loading: false,
                                totalItemsCount: 0,
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get Filtered Meetings Data
     * */
    Serventias.prototype.getMeetingsPagedData = function (offset, limit, filter, sortProperty, sortType, secaoJudiciaria, filterView) {
        return __awaiter(this, void 0, void 0, function () {
            var pinnedAncoras, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        filter = filter ? filter : undefined;
                        secaoJudiciaria = secaoJudiciaria ? secaoJudiciaria : undefined;
                        filterView = filterView ? filterView : this.state.selectedViewFilter;
                        pinnedAncoras = null;
                        if (this.state.pinnedAncoras) {
                            pinnedAncoras = this.state.pinnedAncoras.length ? this.state.pinnedAncoras : null;
                        }
                        this.setState({
                            segmentRows: [],
                            loadingRows: true,
                            activePage: offset
                        });
                        return [4 /*yield*/, serventias_api_1.getMeetingsDataPaged(offset, limit, filter, sortProperty, sortType, secaoJudiciaria, pinnedAncoras, filterView)];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200 && response.data) {
                            this.setState({
                                items: response.data,
                                itemsClone: response.data,
                            });
                            this.populateRows();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get App Configs
     * */
    Serventias.prototype.isAdmin = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, serventias_api_1.isAdmin()];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200 && response.data) {
                            this.setState({
                                isAdmin: response.data,
                                role: roles_1.default.gestor,
                            });
                        }
                        else {
                            this.setState({
                                isAdmin: false,
                            });
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        this.setState({
                            isAdmin: false,
                        });
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ;
    Serventias.prototype.clearFilter = function () {
        var _this = this;
        this.state.itemsSecaoFilter.forEach(function (currentItem) {
            currentItem.isSelected = false;
        });
        this.setState({
            totalFilterChecked: 0,
            itemsSecaoFilter: this.state.itemsSecaoFilter,
            activePage: 0,
            secaoJudiciariaChecked: ""
        }, function () {
            _this.getMeetingsData();
            _this.getMeetingsPagedData(0, _this.state.pageSize, _this.state.searchFilter);
        });
    };
    Serventias.prototype.renderFilters = function (item, index) {
        return (React.createElement("div", { key: index }, this.state.itemsSecaoFilter.length > 0 &&
            React.createElement(react_northstar_1.Flex, null,
                React.createElement(react_northstar_1.FlexItem, null,
                    React.createElement(react_northstar_1.Text, { content: item.name })),
                React.createElement(react_northstar_1.FlexItem, { push: true },
                    React.createElement(react_northstar_1.Checkbox, { key: item.name, id: item.name, checked: item.isSelected, onClick: this.selectFilter.bind(this), className: "group-checkbox dark-theme" })))));
    };
    Serventias.prototype.isLoading = function () {
        return (this.state.loading ||
            this.state.loadingAtendimentosMetricsFiltered ||
            this.state.loadingAtendimentosTotalMetrics ||
            this.state.loadingUnidadesMetricsFiltered ||
            this.state.loadingMetricsFiltered);
    };
    Serventias.prototype.populateRows = function () {
        var _this = this;
        var itemsArr = []; //Populate grid
        if (this.state.items.length) {
            var _loop_1 = function (j) {
                //#region Populate Grid
                if (j >= this_1.state.items.length) {
                    return "break";
                }
                var item = this_1.state.items[j];
                if (this_1.state.pinnedAncoras) {
                    if (this_1.state.pinnedAncoras.some(function (p) { return p === item.ancora; })) {
                        item.favorite = true;
                    }
                    else {
                        item.favorite = false;
                    }
                }
                itemsArr.push(React.createElement(React.Fragment, { key: j },
                    React.createElement(react_northstar_1.Flex, { gap: "gap.medium", vAlign: "center", className: item.isSelected ? "row row-active" : "row" },
                        React.createElement(react_northstar_1.FlexItem, null,
                            React.createElement(react_northstar_1.Checkbox, { key: item.ancora, id: item.ancora, checked: item.isSelected, onClick: this_1.selectCheckboxChanged.bind(this_1), label: item.serventia, className: item.deleted ? "deleted group-checkbox dark-theme" : "group-checkbox dark-theme" }))),
                    React.createElement(react_northstar_1.Flex, { gap: "gap.medium", vAlign: "center", className: item.isSelected ? "row row-active" : "row" },
                        React.createElement("div", { hidden: !this_1.state.isAdmin && this_1.state.role == roles_1.default.leitor },
                            React.createElement(react_northstar_1.FlexItem, null,
                                React.createElement(react_northstar_1.Popup, { trigger: React.createElement(react_icons_northstar_1.MoreIcon, { className: "icon-settings" }), content: React.createElement("div", { className: "div-popup-settings" },
                                        React.createElement(react_northstar_1.Flex, { gap: "gap.small", className: "item-settings" },
                                            React.createElement("div", { hidden: (!this_1.state.isAdmin && (this_1.state.role == roles_1.default.leitor || this_1.state.role == roles_1.default.atendente)) || !this_1.state.setup, style: { width: "100%" }, onClick: function () { return _this.onEditBalcaoVirtual(item.ancora); } },
                                                React.createElement(react_northstar_1.FlexItem, null,
                                                    React.createElement(react_icons_northstar_1.EditIcon, { className: "margin-style", outline: true })),
                                                React.createElement(react_northstar_1.FlexItem, null,
                                                    React.createElement(react_northstar_1.Text, { content: "Editar" })))),
                                        React.createElement(react_northstar_1.Flex, { gap: "gap.small", className: "item-settings" },
                                            React.createElement("div", { hidden: (!this_1.state.isAdmin && (this_1.state.role == roles_1.default.leitor)), onClick: function () {
                                                    return microsoftTeams.executeDeepLink("https://teams.microsoft.com/l/entity/" + _this.searchParam.get("appId") + "/painel?context=" + encodeURI('{"subEntityId": "' + item.ancora + ', ' + item.serventia + '"}'));
                                                } },
                                                React.createElement(react_northstar_1.FlexItem, null,
                                                    React.createElement(react_icons_northstar_1.ShareGenericIcon, { className: "margin-style", outline: true })),
                                                React.createElement(react_northstar_1.FlexItem, null,
                                                    React.createElement(react_northstar_1.Text, { content: "Mostrar Atendimento" })))),
                                        React.createElement(react_northstar_1.Flex, { gap: "gap.small", className: "item-settings" },
                                            React.createElement("div", { hidden: !this_1.state.isAdmin && (this_1.state.role == roles_1.default.leitor || this_1.state.role == roles_1.default.atendente), style: { width: "100%" }, onClick: function () { return _this.copyEnderecoPublicoToClipboard(item.ancora); } },
                                                React.createElement(react_northstar_1.FlexItem, null,
                                                    React.createElement(react_icons_northstar_1.WindowRestoreIcon, { className: "margin-style", outline: true })),
                                                React.createElement(react_northstar_1.FlexItem, null,
                                                    React.createElement(react_northstar_1.Text, { content: "Copiar URL" })))),
                                        React.createElement(react_northstar_1.Flex, { hidden: item.deleted == true, gap: "gap.small", className: "item-settings" },
                                            React.createElement(react_northstar_1.Dialog, { backdrop: false, cancelButton: "Cancelar", confirmButton: "Confirmar", onConfirm: function () { return _this.onDeleteBalcaoVirtual(item.ancora); }, header: "Balc\u00E3o Virtual", content: "Tem certeza que deseja excluir esta Serventia?", trigger: React.createElement("div", { hidden: (!this_1.state.isAdmin && (this_1.state.role == roles_1.default.leitor || this_1.state.role == roles_1.default.atendente)) || !this_1.state.setup, style: { width: "100%" } },
                                                    React.createElement(react_northstar_1.FlexItem, null,
                                                        React.createElement(react_icons_northstar_1.TrashCanIcon, { className: "margin-style", outline: true })),
                                                    React.createElement(react_northstar_1.FlexItem, null,
                                                        React.createElement(react_northstar_1.Text, { content: "Excluir" }))) }))), align: "end", position: "below" })))),
                    React.createElement(react_northstar_1.Flex, { gap: "gap.medium", vAlign: "center", className: item.isSelected ? "row row-active" : "row" },
                        React.createElement(react_northstar_1.FlexItem, null,
                            React.createElement(react_northstar_1.Text, { content: item.secaoJudiciaria }))),
                    React.createElement(react_northstar_1.Flex, { gap: "gap.medium", className: item.isSelected ? "row row-active fluxo" : "row fluxo" }, item.fluxoAtendimento.length > 1 &&
                        React.createElement(react_northstar_1.FlexItem, null,
                            React.createElement(react_northstar_1.Box, { className: "chart-container", content: React.createElement("div", { style: { width: "95px", height: "60px", position: "relative" } },
                                    React.createElement(Chart_1.Chart, { title: "M\u00E9dia de Atendimentos", type: ChartTypes_1.EChartTypes.LineNoAxes, data: {
                                            labels: new Array(item.fluxoAtendimento.length),
                                            datasets: [
                                                {
                                                    data: item.fluxoAtendimento.length ? item.fluxoAtendimento.map(function (item) { return item.sum; }) : [],
                                                }
                                            ],
                                        } }),
                                    React.createElement("div", { style: { position: "absolute", right: "-32px", top: "0", lineHeight: "53px" } }, item.fluxoAtendimentoTotal)) }))),
                    React.createElement(react_northstar_1.Flex, { gap: "gap.medium", vAlign: "center", className: item.isSelected ? "row row-active" : "row" },
                        React.createElement(react_northstar_1.FlexItem, null,
                            React.createElement(react_northstar_1.Text, { content: item.fluxoAtendimentoHoje }))),
                    React.createElement(react_northstar_1.Flex, { gap: "gap.medium", vAlign: "center", className: item.isSelected ? "favorites row row-active" : "favorites row" },
                        React.createElement(react_northstar_1.FlexItem, null,
                            React.createElement(react_icons_northstar_1.StarIcon, { styles: { cursor: "pointer" }, outline: !item.favorite, onClick: function () { return _this.setFavorite(item, item.ancora, j); }, hidden: item.deleted })))));
            };
            var this_1 = this;
            for (var j = 0; j < this.state.items.length; j++) {
                var state_1 = _loop_1(j);
                if (state_1 === "break")
                    break;
            }
        }
        else {
            itemsArr.push(React.createElement(react_northstar_1.Flex, { hAlign: "center", gap: "gap.medium", styles: { marginTop: '60px', gridColumn: 'span 6' } },
                React.createElement(react_icons_northstar_1.ExclamationTriangleIcon, { outline: true }),
                React.createElement(react_northstar_1.Text, { size: "small", weight: "light", content: "N\u00E3o existem unidades para o filtro selecionado." })));
        }
        this.setState({
            loadingRows: false,
            segmentRows: itemsArr
        });
    };
    Serventias.prototype.render = function () {
        var _this = this;
        var pageSize = [10, 25, 50];
        var index = pageSize.indexOf(this.state.pageSize);
        return (this.isLoading() ?
            React.createElement(loader_1.default, null)
            :
                React.createElement("div", { className: "main-component-serventias" },
                    React.createElement("div", { className: "form-container" },
                        React.createElement(react_northstar_1.Flex, { className: "charts", gap: "gap.large", space: "between" },
                            React.createElement(react_northstar_1.FlexItem, { size: "size.quarter" },
                                React.createElement(react_northstar_1.Segment, { styles: { boxShadow: "rgba(0 0 0 / 10%) 0px 0.2rem 0.4rem -0.075rem" } }, React.createElement(visao_geral_atendimentos_1.VisaoGeralAtendimentos, { metrics: this.state.atendimentosMetricsFiltered, totalMetrics: this.state.atendimentosTotalMetrics, filter: this.getAtendimentosFilteredMetrics, index: this.state.atendimentosIndex }))),
                            React.createElement(react_northstar_1.FlexItem, { size: "size.quarter" },
                                React.createElement(react_northstar_1.Segment, { styles: { boxShadow: "rgba(0 0 0 / 10%) 0px 0.2rem 0.4rem -0.075rem" } }, React.createElement(visao_geral_unidades_1.VisaoGeralUnidades, { metrics: this.state.unidadesMetricsFiltered, filter: this.getUnidadesFilteredMetrics, index: this.state.unidadesIndex }))),
                            React.createElement(react_northstar_1.FlexItem, { size: "size.half" },
                                React.createElement(react_northstar_1.Segment, { styles: { boxShadow: "rgba(0 0 0 / 10%) 0px 0.2rem 0.4rem -0.075rem" } }, React.createElement(media_atendimentos_1.MediaAtendimentos, { metrics: this.state.relatorioAtendimentosFilteredMetrics, filter: this.getRelatorioAtendimentosFilteredMetrics, index: this.state.relatorioAtendimentosIndex })))),
                        React.createElement(react_northstar_1.Flex, { space: "between", className: "toolbar-serventias", styles: {
                                position: "sticky",
                                top: 0,
                                padding: "1.25rem 1.25rem 1.25rem 0",
                                margin: "1.25rem 0",
                                boxShadow: "rgb(0 0 0 / 21%) 0 8px 6px -6px",
                                zIndex: 999,
                            } },
                            React.createElement(react_northstar_1.Flex, null, this.state.items.some(function (item) { return item.isSelected == true; }) ?
                                React.createElement(react_northstar_1.Toolbar, { "aria-label": "toolbar-header", items: [
                                        {
                                            content: React.createElement("div", { hidden: (!this.state.isAdmin && (this.state.role == roles_1.default.leitor || this.state.role == roles_1.default.atendente)) || !this.state.setup, onClick: function () { return _this.onEditBalcaoVirtual(_this.state.selectedItem.ancora); }, className: "item-header-toolbar" },
                                                React.createElement(react_icons_northstar_1.EditIcon, { outline: true }),
                                                React.createElement(react_northstar_1.Text, { content: "Editar" })),
                                            key: 'edit',
                                            kind: "custom",
                                            fitted: "horizontally"
                                        },
                                        {
                                            content: React.createElement("div", { className: "item-header-toolbar", onClick: function () {
                                                    return microsoftTeams.executeDeepLink("https://teams.microsoft.com/l/entity/" + _this.searchParam.get("appId") + "/painel?context=" + encodeURI('{"subEntityId": "' + _this.state.selectedItem.ancora + ', ' + _this.state.selectedItem.serventia + '"}'));
                                                } },
                                                React.createElement(react_icons_northstar_1.ShareGenericIcon, { outline: true }),
                                                React.createElement(react_northstar_1.Text, { content: "Painel de Atendimento" })),
                                            key: 'painel-atendimento',
                                            kind: "custom",
                                            fitted: "horizontally"
                                        },
                                        {
                                            content: React.createElement(react_northstar_1.Dialog, { backdrop: false, cancelButton: "Cancelar", confirmButton: "Confirmar", onConfirm: function () { return _this.onDeleteBalcaoVirtual(_this.state.selectedItem.ancora); }, header: "Balc\u00E3o Virtual", content: "Tem certeza que deseja excluir esta Serventia?", trigger: React.createElement("div", { hidden: this.state.selectedItem.deleted },
                                                    React.createElement("div", { hidden: (!this.state.isAdmin && (this.state.role == roles_1.default.leitor || this.state.role == roles_1.default.atendente)) || !this.state.setup, className: "item-header-toolbar" },
                                                        React.createElement(react_icons_northstar_1.TrashCanIcon, { outline: true }),
                                                        React.createElement(react_northstar_1.Text, { content: "Excluir" }))) }),
                                            key: 'delete',
                                            kind: "custom",
                                            fitted: "horizontally"
                                        }
                                    ] })
                                :
                                    React.createElement(react_northstar_1.Flex, { gap: "gap.large", className: "div-btn-new-balcao" },
                                        React.createElement(react_northstar_1.FlexItem, null,
                                            React.createElement(react_northstar_1.Button, { hidden: (!this.state.isAdmin && (this.state.role == roles_1.default.leitor || this.state.role == roles_1.default.atendente)) || !this.state.setup, primary: true, icon: React.createElement(react_icons_northstar_1.CalendarIcon, { outline: true }), content: "Novo Balc\u00E3o Virtual", iconPosition: "before", onClick: this.onNewBalcaoVirtual })),
                                        React.createElement(react_northstar_1.FlexItem, null,
                                            React.createElement(react_northstar_1.Button, { hidden: !this.state.isAdmin, primary: true, icon: React.createElement(react_icons_northstar_1.SettingsIcon, { outline: true }), content: "Configura\u00E7\u00F5es do Servi\u00E7o", iconPosition: "before", onClick: this.configAppSettings })),
                                        React.createElement(react_northstar_1.FlexItem, null,
                                            React.createElement(react_northstar_1.Button, { hidden: !this.state.isAdmin || !this.state.setup || !this.state.reportUrl, primary: true, icon: React.createElement(react_icons_northstar_1.PollIcon, { outline: true }), content: "Dashboard", iconPosition: "before", onClick: this.dashboardTask })))),
                            React.createElement(react_northstar_1.Flex, { gap: "gap.small" },
                                React.createElement(react_northstar_1.Popup, { trigger: React.createElement("div", { className: "div-trigger-filter" },
                                        React.createElement(react_northstar_1.FlexItem, null,
                                            React.createElement(react_icons_northstar_1.FilterIcon, { outline: true, size: "large", styles: this.state.totalFilterChecked > 0 ? { color: 'rgb(139, 140, 199);' } : {} })),
                                        React.createElement(react_northstar_1.FlexItem, null,
                                            React.createElement(react_northstar_1.Text, { className: "margin-style", content: "Filtrar", styles: this.state.totalFilterChecked > 0 ? { color: 'rgb(139, 140, 199);' } : {} }))), content: React.createElement("div", { className: "div-popup-filter" },
                                        React.createElement(react_northstar_1.Flex, null,
                                            React.createElement(react_northstar_1.FlexItem, null,
                                                React.createElement(react_northstar_1.Text, { content: "Filter (" + this.state.totalFilterChecked + ")" })),
                                            React.createElement(react_northstar_1.FlexItem, { push: true },
                                                React.createElement(react_northstar_1.Text, { className: "clear-filter", content: "Clear", color: "brand", onClick: this.clearFilter.bind(this) }))),
                                        React.createElement(react_northstar_1.Flex, { inline: true, style: { display: "block" } },
                                            React.createElement(react_northstar_1.FlexItem, null,
                                                React.createElement(react_northstar_1.Divider, null))),
                                        React.createElement("div", { className: "popup-items-filter" }, this.state.itemsSecaoFilter.map(this.renderFilters.bind(this)))), align: "end", position: "below" }),
                                React.createElement("div", { className: "div-style" },
                                    React.createElement(react_northstar_1.Dropdown, { className: "items-visualizacao", fluid: true, items: this.state.viewFilters, placeholder: "Visualiza\u00E7\u00E3o", highlightedIndex: index, checkable: true, inverted: true, getA11ySelectionMessage: {
                                            onAdd: function (item) {
                                                _this.saveSelectedView(item);
                                                _this.getMeetingsData(undefined, item);
                                                _this.getMeetingsPagedData(0, _this.state.pageSize, _this.state.searchFilter, undefined, undefined, _this.state.secaoJudiciariaChecked, item);
                                                _this.setState({
                                                    activePage: 0,
                                                    pageSize: _this.state.pageSize,
                                                    selectedViewFilter: item,
                                                });
                                                return item.content;
                                            }
                                        }, value: this.state.selectedViewFilter })),
                                React.createElement(react_northstar_1.FlexItem, null,
                                    React.createElement(react_northstar_1.Input, { inverted: true, icon: React.createElement(react_icons_northstar_1.SearchIcon, null), className: "search-box", placeholder: "Pesquisar", onChange: this.search })))),
                        React.createElement("div", { className: "form-content-container" },
                            React.createElement(react_northstar_1.Grid, { columns: "1fr 0.1fr 0.5fr 0.5fr 0.3fr 0.2fr" },
                                React.createElement(react_northstar_1.Flex, { gap: "gap.small", className: "header" },
                                    React.createElement(react_northstar_1.FlexItem, null,
                                        React.createElement(react_northstar_1.Text, { content: "Nome da Unidade", className: "margin-style header-nome-serventia" })),
                                    React.createElement(react_northstar_1.FlexItem, null,
                                        React.createElement(react_northstar_1.Tooltip, { trigger: React.createElement(Icon_1.Icon, { className: "margin-style info-icon", iconName: "Info" }), content: "Nome da Unidade Judicial ou Administrativa atendida por este Balc\u00E3o Virtual" })),
                                    React.createElement(react_northstar_1.FlexItem, null,
                                        React.createElement(Icon_1.Icon, { className: "margin-style title-sort-icon", iconName: this.state.sortDirection, onClick: function () { return _this.sortDataByColumn("Name", "sortDirection"); } }))),
                                React.createElement(react_northstar_1.Flex, { gap: "gap.small" }),
                                React.createElement(react_northstar_1.Flex, { gap: "gap.small", className: "header" },
                                    React.createElement(react_northstar_1.FlexItem, null,
                                        React.createElement(react_northstar_1.Text, { className: "margin-style", content: "Tipo/Categoria" })),
                                    React.createElement(react_northstar_1.FlexItem, null,
                                        React.createElement(react_northstar_1.Tooltip, { trigger: React.createElement(Icon_1.Icon, { className: "margin-style info-icon", iconName: "Info" }), content: "Classifica\u00E7\u00E3o da unidade atendida" })),
                                    React.createElement(react_northstar_1.FlexItem, null,
                                        React.createElement(Icon_1.Icon, { className: "margin-style title-sort-icon", iconName: this.state.sortDirectionSecao, onClick: function () { return _this.sortDataByColumn("SecaoJudiciaria", "sortDirectionSecao"); } }))),
                                React.createElement(react_northstar_1.Flex, { gap: "gap.small", className: "header fluxo" },
                                    React.createElement(react_northstar_1.FlexItem, null,
                                        React.createElement(react_northstar_1.Text, { className: "margin-style", content: "Fluxo de Atendimento" })),
                                    React.createElement(react_northstar_1.FlexItem, null,
                                        React.createElement(react_northstar_1.Tooltip, { trigger: React.createElement(Icon_1.Icon, { className: "margin-style info-icon", iconName: "Info" }), content: "Total de atendimentos iniciados nos \u00FAltimos 7 dias" })),
                                    React.createElement(react_northstar_1.FlexItem, null,
                                        React.createElement(Icon_1.Icon, { hidden: true, className: "margin-style title-sort-icon", iconName: this.state.sortDirectionFluxo, onClick: function () { return _this.sortDataByColumn("FluxoAtendimentoTotal", "sortDirectionFluxo"); } }))),
                                React.createElement(react_northstar_1.Flex, { gap: "gap.small", className: "header" },
                                    React.createElement(react_northstar_1.FlexItem, null,
                                        React.createElement(react_northstar_1.Text, { className: "margin-style", content: "Hoje" })),
                                    React.createElement(react_northstar_1.FlexItem, null,
                                        React.createElement(react_northstar_1.Tooltip, { trigger: React.createElement(Icon_1.Icon, { className: "margin-style info-icon", iconName: "Info" }), content: "Total de atendimentos iniciados hoje" })),
                                    React.createElement(react_northstar_1.FlexItem, null,
                                        React.createElement(Icon_1.Icon, { hidden: true, className: "margin-style title-sort-icon", iconName: this.state.sortDirectionHoje, onClick: function () { return _this.sortDataByColumn("FluxoAtendimentoHoje", "sortDirectionHoje"); } }))),
                                React.createElement(react_northstar_1.Flex, { gap: "gap.small", className: "header" },
                                    React.createElement(react_northstar_1.FlexItem, null,
                                        React.createElement(react_northstar_1.Text, { className: "margin-style", content: "Favorito" })),
                                    React.createElement(react_northstar_1.FlexItem, null,
                                        React.createElement(react_northstar_1.Tooltip, { trigger: React.createElement(Icon_1.Icon, { className: "margin-style info-icon", iconName: "Info" }), content: "Utilize esta op\u00E7\u00E3o para priorizar esta unidade na listagem e para habilitar as notifica\u00E7\u00F5es" })),
                                    React.createElement(react_northstar_1.FlexItem, null,
                                        React.createElement(Icon_1.Icon, { className: "margin-style title-sort-icon", iconName: "Down", onClick: function () { return _this.sortDataByColumn("Favorite", "Down"); } }))),
                                this.state.loadingRows &&
                                    React.createElement(react_northstar_1.Segment, { styles: { gridColumn: 'span 6', background: 'transparent', paddingTop: '0px', boxShadow: 'none' } },
                                        React.createElement(loaderList_1.default, null)),
                                !this.state.loadingRows && this.state.segmentRows))),
                    React.createElement("div", { className: "footer-container" },
                        this.state.selectedViewFilter == serventias_filters_1.default.favoritos &&
                            React.createElement("div", { className: "favInfo" },
                                React.createElement(react_northstar_1.Text, { content: "Para visualizar todas as unidades, ", size: "small", weight: "light" }),
                                React.createElement(react_northstar_1.Text, { content: "clique aqui.", onClick: function () {
                                        _this.getMeetingsData(undefined, serventias_filters_1.default.ativos);
                                        _this.getMeetingsPagedData(0, _this.state.pageSize, _this.state.searchFilter, undefined, undefined, _this.state.secaoJudiciariaChecked, serventias_filters_1.default.ativos);
                                        _this.setState({
                                            activePage: 0,
                                            pageSize: _this.state.pageSize,
                                            selectedViewFilter: serventias_filters_1.default.ativos,
                                        });
                                    }, size: "small", weight: "bold", styles: { cursor: 'pointer' } })),
                        React.createElement(react_northstar_1.Flex, { gap: "gap.medium", padding: "padding.medium", hAlign: "center" },
                            React.createElement(react_northstar_1.FlexItem, { push: true, align: "center" },
                                React.createElement(pagination_1.default, { callbackFromParent: this.setActivePage, entitiesLength: this.state.totalItemsCount, activePage: this.state.activePage, numberOfContents: this.state.pageSize }))),
                        React.createElement(react_northstar_1.Flex, { hAlign: "end", styles: { marginTop: '-42px' } },
                            React.createElement(react_northstar_1.FlexItem, { align: "end" },
                                React.createElement("div", { className: "div-style" },
                                    React.createElement(react_northstar_1.Dropdown, { fluid: true, items: pageSize, placeholder: "Itens por p\u00E1gina", highlightedIndex: index, checkable: true, inverted: true, getA11ySelectionMessage: {
                                            onAdd: function (item) {
                                                _this.getMeetingsData();
                                                _this.getMeetingsPagedData(0, item, _this.state.searchFilter, undefined, undefined, _this.state.secaoJudiciariaChecked, _this.state.selectedViewFilter);
                                                _this.setState({
                                                    activePage: 0,
                                                    pageSize: item,
                                                });
                                                return item.content;
                                            }
                                        } })))))));
    };
    return Serventias;
}(React.Component));
exports.Serventias = Serventias;
//# sourceMappingURL=serventias.js.map